import React from 'react';
import { Container } from '@mui/material';

function PrivacyPolicy() {
    return <Container></Container>;
}
export default PrivacyPolicy;
